import { useMemo as y, useCallback as v } from "react";
import { useRouter as R } from "next/router";
import { u as P } from "./use-sitecore-context.C7g4vcbm.js";
const _ = (c, o) => {
  const { path: d, ...u } = o;
  return { ...u, sc_lang: c };
}, O = (c) => {
  const o = R(), { sitecoreContext: d } = P(), u = o.defaultLocale || "en-US", I = d == null ? void 0 : d.language, l = I || u, a = y(
    () => {
      var r;
      return (r = c == null ? void 0 : c.fields) == null ? void 0 : r.map((e) => {
        const { friendlyName: t } = e.fields, { fields: s } = e.fields.language;
        return { friendlyName: t, ...s };
      });
    },
    [c]
  ), h = v(() => {
    const { path: r } = o.query;
    if (Array.isArray(r)) {
      const e = r.filter(Boolean), t = e.findIndex((s) => s.startsWith("_site_"));
      return t >= 0 && e.splice(t, 1), `/${e.join("/")}`;
    } else if (typeof r == "string") {
      const e = r.replace(/\/?_site_[^/]+\/?/g, "");
      return e ? `/${e}` : "/";
    }
    return o.pathname;
  }, [o.query, o.pathname]), m = y(() => {
    const r = h(), e = o.query;
    return a.map((t) => {
      var f, i;
      const s = ((f = t.regionalIsoCode) == null ? void 0 : f.value) || ((i = t["Regional Iso Code"]) == null ? void 0 : i.value) || u, n = _(s, e);
      return {
        ...t,
        // helps with prefetching -> add as href to Link
        targetHref: {
          pathname: r,
          query: n
        }
      };
    });
  }, [h, o.query, a, u]), q = y(
    () => {
      var r, e;
      return (e = (r = a == null ? void 0 : a.find(
        (t) => {
          var s, n;
          return ((s = t == null ? void 0 : t.regionalIsoCode) == null ? void 0 : s.value) === l || ((n = t == null ? void 0 : t["Regional Iso Code"]) == null ? void 0 : n.value) === l;
        }
      )) == null ? void 0 : r.friendlyName) == null ? void 0 : e.value;
    },
    [a, l]
  ), H = v(
    (r) => {
      var s, n, p, f;
      const e = m.find(
        (i) => {
          var C;
          return ((C = i == null ? void 0 : i.friendlyName) == null ? void 0 : C.value) === r;
        }
      );
      if (!e || !((s = e.regionalIsoCode) != null && s.value) && !((n = e["Regional Iso Code"]) != null && n.value) || !e.targetHref) {
        console.warn(
          "Selected language not found or missing ISO code/target href:",
          r
        );
        return;
      }
      const t = ((p = e == null ? void 0 : e.regionalIsoCode) == null ? void 0 : p.value) || ((f = e == null ? void 0 : e["Regional Iso Code"]) == null ? void 0 : f.value);
      o.replace(
        {
          pathname: e.targetHref.pathname,
          // Canonical path (e.g., /about)
          query: e.targetHref.query
          // Query object with sc_lang
        },
        e.targetHref,
        {
          locale: t
        }
      );
    },
    [o, m]
  );
  return { availableLanguages: m, selectedFriendlyName: q, changeLanguage: H };
};
export {
  O as u
};
